export default "__VITE_ASSET__CMzbB0qR__"